"use strict";
/**
 * @module Services.GatewayControl
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var gateway_request_type_1 = require("./../../../services/gateway-control/gateway-request-type");
var base_gateway_service_request_1 = require("./../../../services/gateway-control/services/base-gateway-service-request");
/**
 * Data type for a GATEWAY_CLIENT_REQUEST service-targeted get operation detail request.
 */
var GatewayServiceGetOperationDetailRequest = /** @class */ (function (_super) {
    __extends(GatewayServiceGetOperationDetailRequest, _super);
    /**
     * Create a new GatewayServiceGetOperationDetailRequest instance
     *
     * @param sessionId  the gateway client session id
     * @param serviceId  the service id
     * @param operationName  the name of the operation to get details for
     */
    function GatewayServiceGetOperationDetailRequest(sessionId, serviceId, operationName) {
        var _this = _super.call(this, sessionId, serviceId) || this;
        _this.type = gateway_request_type_1.GatewayRequestType.GET_SERVICE_OPERATION_DETAIL;
        _this.operationName = operationName;
        return _this;
    }
    return GatewayServiceGetOperationDetailRequest;
}(base_gateway_service_request_1.BaseGatewayServiceRequest));
exports.GatewayServiceGetOperationDetailRequest = GatewayServiceGetOperationDetailRequest;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/gateway-control/services/service-get-operation-detail-request.js
// module id = 1392
// module chunks = 0